import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DevicesPartialState } from './devices.reducer';
import { DevicesQuery } from './devices.selectors';
import * as DevicesActions from './devices.actions';
import { ActionWithCorrelationAttributes } from '@kion/ngrx-helper';
import { Device } from '@kion/data-models';

@Injectable()
export class DevicesFacade {
  all$ = this.store.pipe(select(DevicesQuery.getAllDevices));
  allById$ = this.store.pipe(select(DevicesQuery.getAllDevicesById));
  searchResults$ = this.store.pipe(select(DevicesQuery.getSearchResults));
  isSearching$ = this.store.pipe(select(DevicesQuery.getIsSearching));
  lastCreatedId$ = this.store.pipe(select(DevicesQuery.getLastCreatedId));
  pagination$ = this.store.pipe(select(DevicesQuery.getPagination));
  sorts$ = this.store.pipe(select(DevicesQuery.getSorts));
  facets$ = this.store.pipe(select(DevicesQuery.getFacets));
  totalResult$ = this.store.pipe(select(DevicesQuery.getTotalResults));
  query$ = this.store.pipe(select(DevicesQuery.getQuery));

  constructor(private store: Store<DevicesPartialState>) {}

  protected dispatch(
    action,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }
  search(
    query?: string,
    useState: boolean = false,
    useDefaultPage: boolean = false,
    sort?: string,
    mixedMode: boolean = false,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DevicesActions.search({
        query: query,
        useState: useState,
        useDefaultPage: useDefaultPage,
        sort: sort,
        mixedMode,
      }),
      correlationId
    );
  }
  loadById(
    factory: string,
    id: string,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DevicesActions.loadById({ factory: factory, id: id }),
      correlationId
    );
  }
  removeDevicesFromStore(
    devices: Device[],
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DevicesActions.removeDevicesFromStore({ devices: devices }),
      correlationId
    );
  }
  updatePerPage(
    perPage: number,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DevicesActions.updatePerPage({ perPage: perPage }),
      correlationId
    );
  }
  updatePage(
    page: number,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DevicesActions.updatePage({ page: page }),
      correlationId
    );
  }
  updateSort(
    sort: string,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      DevicesActions.updateSort({ sort: sort }),
      correlationId
    );
  }
}
